export function ChecklistProgressBar({
	progress,
	completed,
	total,
}: {
	progress: number;
	completed: number;
	total: number;
}) {
	return (
		<div className="mb-3">
			<div className="flex items-center justify-between mb-1.5">
				<span className="text-xs text-muted">
					{completed} of {total} complete
				</span>
				<span className="text-xs font-medium text-primary">{progress}%</span>
			</div>
			<div className="h-1.5 w-full rounded-full bg-muted-subtle overflow-hidden">
				<div
					className="h-full bg-primary transition-all"
					style={{ width: `${progress}%` }}
				/>
			</div>
		</div>
	);
}
